import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export function PhysicalSignatureSuccessDialog({
    dialogOpen,
    setDialogOpen
}) {
    const [open, setOpen] = useState(dialogOpen);

    const cancelButtonRef = useRef(null);

    const handleToggleDialog = () => {
        setDialogOpen(!dialogOpen);
    };

    return (
        <>
            <Transition.Root show={open} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-50"
                    initialFocus={cancelButtonRef}
                    onClose={handleToggleDialog}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-tdark bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="text-tdark font-walsheim tracking-tight relative transform overflow-auto rounded-lg bg-white text-left shadow-xl transition-all my-8 max-w-sm p-6">
                                    <div>
                                        <div className="">
                                            <div className="flex justify-end w-full">
                                                <XMarkIcon
                                                    className="w-6 h-auto text-md flex justify-center border border-transparent rounded-full font-semibold text-tdark bg-purpleLight transition duration-300 focus:outline-none cursor-pointer"
                                                    onClick={handleToggleDialog}
                                                />
                                            </div>
                                            <div className="text-center mt-3 sm:mt-5">
                                                <Dialog.Title as="h1" className="text-xl font-semibold">
                                                    Proceso exitoso!
                                                </Dialog.Title>
                                            </div>

                                            <div className="mt-2">

                                                <div className="mt-4">
                                                    <p className="text-sm">
                                                        Hemos enviado a tu correo electrónico un email con los documentos que debes firmar.
                                                    </p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex mt-2 pt-6">
                                        <div className="flex gap-2 w-full">
                                            <div className="w-full">
                                                <button
                                                onClick={handleToggleDialog}
                                                    className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-md font-semibold text-white bg-purple hover:bg-purpleDark transition duration-300  focus:outline-none`}
                                                >
                                                   Ok
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
}
